import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import RichTextEditor from "react-rte";
import { Button } from "reactstrap";
import { API_END_POINT } from "../config";
import Select from "react-select";
import "react-select/dist/react-select.css";

import Cookie from "js-cookie";
import moment from "moment";
import { JWT_SECRET_TOKEN } from "../config";
const jwt = require("jsonwebtoken");
const token = Cookie.get("waffle_world_access_token");

export default class CityForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      order: {
        // numberOfOrders: 0,
        userId: "",
        userAddress: "pickup",
        status: "",
        totalPrice: "",
        items: [],
        description: " This Order Is from Admin panel",
      },
      users: [],
      user: "",
      items: [],
      item: [],
      gallery: "",
      description: RichTextEditor.createEmptyValue(),
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.postOrder = this.postOrder.bind(this);
  }

  fetchUsers = (value) => {
    this.setState({
      status: value,
      acceptedUsers: [],
      unAcceptedUsers: [],
      loading: true,
      responseMessage: "Loading Users...",
    });
    const tokenx = jwt.sign({ payload: value }, JWT_SECRET_TOKEN, {
      expiresIn: "1h",
    });
    axios
      .get(`${API_END_POINT}/api/users`, {
        headers: { "auth-token": tokenx, "x-api-key": JWT_SECRET_TOKEN },
      })
      .then((response) => {
        this.setState({
          users: response.data.objects,
        });
        // console.log(this.state.users);
      });
  };

  componentWillMount() {
    const { match } = this.props;
    this.fetchUsers(this.state.status);
    axios
      .get(`${API_END_POINT}/api/items`, { headers: { "auth-token": token } })
      .then((response) => {
        const filteredResponce = response.data.objects.filter(
          (item) => item.quantity !== 0 && item.isActive === true
        );
        if (match.params.orderId) {
          filteredResponce.forEach(
            (item) => (
              (item.numberOfOrders = 300),
              (item.previousOrderNumber = 0),
              (item.itemId = item._id),
              delete item._id
            )
          );
        } else {
          filteredResponce.forEach(
            (item) => (
              (item.numberOfOrders = 300),
              (item.itemId = item._id),
              delete item._id
            )
          );
        }
        this.setState({
          items: filteredResponce,
          loading: false,
        });
      });
  }

  componentDidMount() {
    const { match } = this.props;
    if (match.params.orderId) {
      axios
        .get(`${API_END_POINT}/api/orders/one`, {
          params: { orderId: match.params.orderId },
          headers: { "auth-token": token },
        })
        .then((response) => {
          this.setState(
            {
              order: response.data.object[0],
              item: response.data.object[0].items,
            },
            () => {
              this.getUserFromId();
              this.getItembyId();
            }
          );
        });
    }
  }

  getUserFromId = () => {
    axios
      .get(`${API_END_POINT}/api/users/one`, {
        params: { userId: this.state.order.userId },
      })
      .then((response) => {
        this.setState({
          user: response.data.object[0],
        });
      });
  };

  getItembyId = () => {
    axios
      .get(`${API_END_POINT}/api/items/one`, {
        params: { itemId: this.state.order.itemId },
        headers: { "auth-token": token },
      })
      .then((response) => {
        this.setState({
          item: response.data.object[0],
        });
      });
  };

  setDescription(description) {
    const { order } = this.state;
    order.description = description.toString("html");
    this.setState({
      order,
      description,
    });
  }

  handleInputChange(event) {
    const { value, name } = event.target;

    const { order } = this.state;
    order[name] = value;
    this.setState({ order });
  }

  handleImages = (event) => {
    this.setState({ gallery: event.target.files });
  };

  postOrder(event) {
    event.preventDefault();
    const { match } = this.props;
    let { order, item } = this.state;
    order.items = item;
    order.orderDate = moment().format();
    this.setState({ loading: true, order }, () => {
      if (match.params.orderId) {
        order.orderId = order._id;
        delete order["_id"];
        delete order["userId"];
        delete order["itemId"];
        delete order["date"];
        delete order["__v"];
        delete order["orderTime"];
        delete order["orderDate"];
        delete order["orderNumber"];
        axios
          .post(`${API_END_POINT}/api/orders/update`, order, {
            headers: { "auth-token": token },
          })
          .then((response) => {
            if (response.status === 200) {
              window.alert(response.data.msg);
              this.setState({ loading: false });
              this.props.history.goBack();
            } else {
              window.alert(response.data.error);
              this.setState({ loading: false });
            }
          })
          .catch((error) => {
            this.setState({
              loading: false,
            });
          });
      } else {
        const tokenx = jwt.sign({ payload: "value" }, JWT_SECRET_TOKEN, {
          expiresIn: "1h",
        });
        axios
          .post(`${API_END_POINT}/api/orders/`, order, {
            headers: { "auth-token": tokenx, "x-api-key": JWT_SECRET_TOKEN },
          })
          .then((response) => {
            if (response.status === 200) {
              window.alert(response.data.msg);
              this.setState({ loading: false });
              this.props.history.goBack();
            } else {
              window.alert(response.data.error);
              this.setState({ loading: false });
            }
          })
          .catch((error) => {
            this.setState({
              loading: false,
            });
          });
      }
    });
    // order.items.push(...item);
  }

  setUser = (selectedUser) => {
    this.setState((prevState) => ({
      user: selectedUser,
      order: {
        ...prevState.order,
        userName: selectedUser.firstname + " " + selectedUser.lastname,
        userEmail: selectedUser.email,
        userId: selectedUser._id,
        phoneNumber: selectedUser.phoneNumber,
      },
    }));
    // console.log(selectedUser);
  };

  setItem(selectedItem) {
    console.log("selectedItem==>", selectedItem);
    this.setState(
      {
        item: selectedItem,
      },
      this.getPrice
    );
  }
  removeInNumbers = (index) => {
    const cartItems = [...this.state.item];
    cartItems[index].numberOfOrders = cartItems[index].numberOfOrders - 100;
    this.setState(
      {
        item: cartItems,
      },
      this.getPrice
    );
  };
  addInNumbers = (index) => {
    const cartItems = [...this.state.item];
    cartItems[index].numberOfOrders =
      Number(cartItems[index].numberOfOrders) + 100;
    this.setState(
      {
        item: cartItems,
      },
      this.getPrice
    );
  };
  getPrice = () => {
    let array = this.state.item;
    let totalPrice = 0;
    array.forEach((item) => {
      totalPrice = totalPrice + (item.numberOfOrders / 1000) * item.price;
    });
    this.setState({
      order: {
        ...this.state.order,
        totalPrice: parseFloat(totalPrice.toFixed(2)),
      },
    });
  };

  render() {
    const { loading, order, description, user, users, item, items } =
      this.state;
    console.log(this.state);
    console.log("Benutzer" + this.state.users);
    const updatedUsers = users.map((user) => ({
      ...user,
      fullName: `${user.firstname} ${user.lastname}`,
    }));
    console.log(updatedUsers);
    return (
      <div className="row animated fadeIn">
        <div className="col-12">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="x_panel">
                <div className="x_title">
                  <h2>Bestelldetails eingeben:</h2>
                </div>
                <div className="x_content">
                  <br />
                  <form
                    id="demo-form2"
                    data-parsley-validate
                    className="form-horizontal form-label-left"
                    onSubmit={this.postOrder}
                  >
                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Benutzer auswählen:
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <Select
                          name="itemId"
                          value={user}
                          onChange={(value) => this.setUser(value)}
                          options={updatedUsers}
                          valueKey="_id"
                          labelKey="fullName"
                          clearable={false}
                          backspaceRemoves={false}
                          required
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Artikel
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <Select
                          multi
                          name="itemId"
                          value={item}
                          onChange={(value) => this.setItem(value)}
                          options={items}
                          valueKey="itemId"
                          labelKey="name"
                          clearable={false}
                          backspaceRemoves={false}
                          required
                        />
                      </div>
                    </div>

                    {item.length > 0 && (
                      <div className="form-group row">
                        <label className="control-label col-md-3 col-sm-3">
                          Ausgewählte Artikel
                        </label>
                        <div className="col-md-6 col-sm-6">
                          {item.length > 0 && (
                            <table
                              className="table table-striped"
                              style={{ width: "100%" }}
                            >
                              <thead>
                                <tr>
                                  <th>Artikel Nummer.</th>
                                  <th>Ausgewählte Artikel</th>
                                  <th>Anzahl Gramm</th>
                                </tr>
                              </thead>
                              <tbody>
                                {item &&
                                  item.map((selectedItems, index) => (
                                    <tr>
                                      <td style={{ width: "10px" }}>
                                        {index + 300}
                                      </td>
                                      <td>{selectedItems.name}</td>
                                      <td style={{ width: "200px" }}>
                                        <div className="text-center d-flex">
                                          <button
                                            type="button"
                                            disabled={
                                              selectedItems.numberOfOrders <=
                                              300
                                            }
                                            onClick={() =>
                                              this.removeInNumbers(index)
                                            }
                                          >
                                            -
                                          </button>
                                          <p className="m-auto">
                                            {selectedItems.numberOfOrders} g
                                          </p>
                                          <button
                                            type="button"
                                            onClick={() =>
                                              this.addInNumbers(index)
                                            }
                                          >
                                            +
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          )}
                        </div>
                      </div>
                    )}
                    {item.length > 0 && (
                      <div className="form-group row">
                        <label className="control-label col-md-3 col-sm-3">
                          Gesamt Preis :
                        </label>
                        <h5 className="px-3"> {order.totalPrice} €</h5>
                      </div>
                    )}
                    {/* <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        No. of orders
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="number"
                          name="numberOfOrders"
                          className="form-control"
                          value={order.numberOfOrders}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div> */}

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Bestellstatus
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <select
                          name="status"
                          value={order.status}
                          className="form-control"
                          onChange={this.handleInputChange}
                          required
                        >
                          <option value="">Select Value</option>
                          <option value="active">Active</option>
                          <option value="ready">Ready</option>
                          <option value="delivered">Delivered</option>
                        </select>
                      </div>
                    </div>

                    <div className="ln_solid" />
                    <div className="form-group row">
                      <div className="col-md-6 col-sm-6 offset-md-3">
                        <Button
                          type="submit"
                          className={`btn btn-success btn-lg ${
                            this.state.loading ? "disabled" : ""
                          }`}
                        >
                          <i
                            className={`fa fa-spinner fa-pulse ${
                              this.state.loading ? "" : "d-none"
                            }`}
                          />{" "}
                          Bestätigen
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/OrderForm.jsx